// var url = window.location.origin

// export const BaseUrl = "https://apimilso.cdat.work"




var url = window.location.origin

export const BaseUrl =
    url == "http://milso.co.in" ? "http://api.milso.co.in" :
        url == "https://milso.co.in" ? "https://api.milso.co.in" :
            "https://apimilso.cdat.work"
